/**
 * useAuth hook — convenience access to auth state.
 *
 * Wraps Redux selectors so components don't need to import slice
 * internals. Returns the most useful auth values in one call.
 */

import { useSelector } from 'react-redux';
import {
  selectAccessToken,
  selectIsAuthenticated,
  selectUser,
  selectIsRefreshing,
  selectProfileLoaded,
} from '@/store/authSlice';

export function useAuth() {
  const accessToken = useSelector(selectAccessToken);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector(selectUser);
  const isRefreshing = useSelector(selectIsRefreshing);
  const profileLoaded = useSelector(selectProfileLoaded);

  return {
    accessToken,
    isAuthenticated,
    user,
    isRefreshing,
    profileLoaded,
  };
}
